(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1134],{

/***/ 80136:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/hand-right.b735ee70.svg","height":251,"width":332});

/***/ }),

/***/ 67687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _action_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23094);

// @ts-expect-error - Automatic, Please fix when editing this file
var setChoosableComparerProductId = function(productId) {
    return function(dispatch) {
        return dispatch({
            comparerProductId: productId,
            type: _action_types__WEBPACK_IMPORTED_MODULE_0__/* .CHOOSABLE_SET_COMPARER_PRODUCT_ID */ .Xy
        });
    };
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    setChoosableComparerProductId: setChoosableComparerProductId
});


/***/ }),

/***/ 9010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ banner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/content/utils/generate-portable-text/index.js
var generate_portable_text = __webpack_require__(5398);
var generate_portable_text_default = /*#__PURE__*/__webpack_require__.n(generate_portable_text);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/client/cms/constants/index.ts
var constants = __webpack_require__(28937);
// EXTERNAL MODULE: ./src/client/components/offers/utils/filterOffers/index.tsx
var filterOffers = __webpack_require__(91186);
// EXTERNAL MODULE: ./src/client/components/offers/tile/utils/get-content-for-offer/index.ts
var get_content_for_offer = __webpack_require__(95897);
;// CONCATENATED MODULE: ./src/client/components/offers/utils/has-end-punctuation/index.ts
var END_OF_SENTENCE_PUNCTUATION = /([?!.,:-])$/;
var hasEndPunctuation = function(text) {
    return END_OF_SENTENCE_PUNCTUATION.test(text);
};
/* harmony default export */ var has_end_punctuation = (hasEndPunctuation);

// EXTERNAL MODULE: ./src/client/components/offers/serializers/placeholder/index.tsx
var placeholder = __webpack_require__(44724);
;// CONCATENATED MODULE: ./src/client/components/offers/banner/components/offer-header/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n\n  & > p {\n    display: inline;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var PortableTextInline = (0,styled_components_browser_esm["default"])(ahm_ui/* PortableText */.YI).withConfig({
    componentId: "sc-64a49240-0"
})(_templateObject());
var OfferBannerHeader = function(param) {
    var header = param.header, placeholders = param.placeholders, offer = param.offer, rewards = param.rewards;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PortableTextInline, {
        typeSerializers: {
            placeholder: (0,placeholder/* default */.Z)({
                offer: offer,
                placeholders: placeholders,
                rewards: rewards
            })
        },
        source: generate_portable_text_default()(header)
    });
};
/* harmony default export */ var offer_header = (OfferBannerHeader);

// EXTERNAL MODULE: ./src/client/components/offers/images/offer-tag.svg
var offer_tag = __webpack_require__(9788);
// EXTERNAL MODULE: ./src/client/selectors/select-referral-code/index.ts
var select_referral_code = __webpack_require__(25535);
// EXTERNAL MODULE: ./src/client/components/offers/logic/use-get-active-promo-offer/index.ts
var use_get_active_promo_offer = __webpack_require__(8235);
;// CONCATENATED MODULE: ./src/client/components/offers/banner/index.tsx


function banner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: 1rem;\n\n  ",
        "\n"
    ]);
    banner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}















var OfferBannerSection = (0,styled_components_browser_esm["default"])(ahm_ui/* Section */.$0).withConfig({
    componentId: "sc-4f5fe7cd-0"
})(banner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.purpleTint;
}, function(param) {
    var isInHeroBanner = param.isInHeroBanner, theme = param.theme;
    return isInHeroBanner && "\n      border-bottom: 1px solid ".concat(theme.colors.purple, ";\n\n      @media (min-width: ").concat(theme.media.sm, ") {\n        border-left: 0.5rem solid ").concat(theme.colors.black, ";\n        border-right: 0.5rem solid ").concat(theme.colors.black, ";\n        margin-left: auto;\n        margin-right: auto;\n        max-width: ").concat(theme.grid.wrapperWidthExtraExtraLarge, ";\n      }\n  ");
});
var CodeCopyInline = (0,styled_components_browser_esm["default"])(ahm_ui/* CodeCopy */.ZX).withConfig({
    componentId: "sc-4f5fe7cd-1"
})(_templateObject1());
var StyledCol = (0,styled_components_browser_esm["default"])(ahm_ui/* Col */.JX).withConfig({
    componentId: "sc-4f5fe7cd-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var StyledSpan = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-4f5fe7cd-3"
})(_templateObject3());
var OfferBanner = function(param) {
    var filterProductId = param.filterProductId, overrideOffers = param.overrideOffers, placeholders = param.placeholders, _targetSegment = param.targetSegment, targetSegment = _targetSegment === void 0 ? constants/* TARGET_SEGMENT.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE */.TZ.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE : _targetSegment, presaleSentence = param.presaleSentence, presaleEnd = param.presaleEnd, rewards = param.rewards, isInHeroBanner = param.isInHeroBanner;
    var ref, ref1, ref2;
    var activeOffers = (0,use_get_active_promo_offer/* default */.Z)({
        skip: !(0,fp.isEmpty)(overrideOffers),
        targetSegment: targetSegment
    }).activeOffers;
    var referralCode = (0,es/* useSelector */.v9)(select_referral_code/* default */.Z);
    if ((0,fp.isEmpty)(activeOffers) && (0,fp.isEmpty)(overrideOffers)) {
        return null;
    }
    var getOffersToDisplay = function() {
        var offers = overrideOffers || activeOffers;
        return filterProductId ? (0,filterOffers/* default */.Z)({
            filterProductId: filterProductId,
            offers: offers
        }) : offers;
    };
    var offer = (0,fp.last)(getOffersToDisplay());
    var ref3 = (0,get_content_for_offer/* default */.Z)(offer, referralCode), ends = ref3.ends, header = ref3.header, promoCode = ref3.promoCode, subtext = ref3.subtext;
    var headerText = (ref = generate_portable_text_default()(header)) === null || ref === void 0 ? void 0 : (ref1 = ref.children) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.text;
    // adding whitespace between sentences
    var endOfSentence = has_end_punctuation(headerText) ? " " : ". ";
    var ref4, ref5;
    var allOfferCopy = {
        // @ts-expect-error - Automatic, Please fix when editing this file
        value: (0,_to_consumable_array/* default */.Z)((ref4 = subtext === null || subtext === void 0 ? void 0 : subtext.value) !== null && ref4 !== void 0 ? ref4 : {}).concat([
            {
                value: " "
            }
        ], (0,_to_consumable_array/* default */.Z)((ref5 = ends === null || ends === void 0 ? void 0 : ends.value) !== null && ref5 !== void 0 ? ref5 : {}))
    };
    var offerText = subtext && ends ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
        source: generate_portable_text_default()(allOfferCopy)
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
        source: generate_portable_text_default()(subtext || ends)
    });
    var ref6, ref7;
    var presaleTextSummary = presaleSentence && presaleEnd ? {
        value: (0,_to_consumable_array/* default */.Z)((ref6 = presaleSentence === null || presaleSentence === void 0 ? void 0 : presaleSentence.value) !== null && ref6 !== void 0 ? ref6 : {}).concat([
            {
                value: " "
            }
        ], (0,_to_consumable_array/* default */.Z)((ref7 = presaleEnd === null || presaleEnd === void 0 ? void 0 : presaleEnd.value) !== null && ref7 !== void 0 ? ref7 : {}))
    } : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferBannerSection, {
        isInHeroBanner: isInHeroBanner,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Row */.X2, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCol, {
                    df: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                        src: offer_tag/* default.src */.Z.src,
                        alt: "Offer"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Col */.JX, {
                    xs: 12,
                    df: 11,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.H2, {
                            looksLike: "h5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(offer_header, {
                                    header: header,
                                    offer: offer,
                                    placeholders: placeholders,
                                    rewards: rewards
                                }),
                                endOfSentence,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSpan, {
                                    children: [
                                        "Use ",
                                        promoCode !== referralCode && "our",
                                        " code:"
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeCopyInline, {
                                    asTextLink: true,
                                    codeValue: promoCode
                                })
                            ]
                        }),
                        presaleTextSummary ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                            source: generate_portable_text_default()(presaleTextSummary)
                        }) : offerText
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var banner = (OfferBanner);


/***/ }),

/***/ 53138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ambulance_section; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/ambulance-section/images/ambulance.svg
/* harmony default export */ var ambulance = ({"src":"/_next/static/media/ambulance.db6e44ff.svg","height":81,"width":91});
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/ambulance-section/data.ts

var data = {
    image: {
        alt: "ambulance with lights flashing",
        src: ambulance.src
    },
    summary: [
        "TAS/QLD State schemes cover ambulance services for residents of those States.",
        "1 day waiting period applies.", 
    ],
    title: "Plus unlimited emergency ambulance"
};
/* harmony default export */ var ambulance_section_data = (data);

// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/ambulance-section/styles.module.sass
var styles_module = __webpack_require__(41732);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/utils/uncap-fp-iterator.ts
var uncap_fp_iterator = __webpack_require__(96852);
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/ambulance-section/index.tsx









var AmbulanceSection = function(param) {
    var _isStacked = param.isStacked, isStacked = _isStacked === void 0 ? false : _isStacked;
    var image = ambulance_section_data.image, summary = ambulance_section_data.summary, title = ambulance_section_data.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Section */.$0, {
        variant: [
            "paddingTopSpacer9",
            "paddingBottomSpacerNone"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Wrapper */.im, {
            className: classnames_default()((styles_module_default()).wrapper, (0,_define_property/* default */.Z)({}, (styles_module_default()).isStacked, isStacked)),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* SpacerWrapper */.Cj, {
                    variant: "paddingBottomSpacer11",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                            looksLike: "h4",
                            variant: "simpleBit",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                            variant: "small14",
                            children: (0,uncap_fp_iterator/* default */.Z)(fp.map)(// @ts-expect-error - Automatic, Please fix when editing this file
                            function(line, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        line,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                    ]
                                }, index);
                            }, summary)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    className: classnames_default()((styles_module_default()).image, (0,_define_property/* default */.Z)({}, (styles_module_default()).isStacked, isStacked)),
                    src: image.src,
                    alt: image.alt
                })
            ]
        })
    });
};
/* harmony default export */ var ambulance_section = (AmbulanceSection);


/***/ }),

/***/ 23996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ base_bundle_section; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/constants/lib/src/index.js
var src = __webpack_require__(13294);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/client/utils/get-orthodontics-lifetime-limit/index.ts
var get_orthodontics_lifetime_limit = __webpack_require__(3110);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/service-group-panel/index.tsx + 4 modules
var service_group_panel = __webpack_require__(89634);
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/base-bundle-section/images/tooth.svg
/* harmony default export */ var tooth = ({"src":"/_next/static/media/tooth.927bd60a.svg","height":132,"width":91});
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/base-bundle-section/index.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -1.5rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: initial;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var SectionWrapper = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-47f35ffa-0"
})(_templateObject());
var AnchorId = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-47f35ffa-1"
})(_templateObject1());
var PanelImage = (0,styled_components_browser_esm["default"])(ahm_ui/* Image */.Ee).withConfig({
    componentId: "sc-47f35ffa-2"
})(_templateObject2());
var BaseBundleSection = function(param) {
    var includedServices = param.includedServices, scale = param.scale, _isBundleChosen = param.isBundleChosen, isBundleChosen = _isBundleChosen === void 0 ? false : _isBundleChosen;
    if (!includedServices) {
        return null;
    }
    var limits = includedServices.limits;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnchorId, {
                id: "base-bundle-section"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Wrapper */.im, {
                size: "medium",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* SpacerWrapper */.Cj, {
                    variant: "marginBottomSpacer7",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                        looksLike: "h3",
                        variant: "center",
                        children: "Start with our base bundle\xa0…"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(service_group_panel/* default */.Z, {
                id: src.PRODUCT_LIMIT_CATEGORY.TEETH,
                isDisabled: true,
                isSelected: true,
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)(PanelImage, {
                    src: tooth.src,
                    alt: "Illustration of a tooth"
                }),
                limits: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, limits), {
                    lifetime: (0,get_orthodontics_lifetime_limit/* default */.Z)(includedServices.services)
                }),
                scale: scale,
                services: includedServices.services,
                title: includedServices.displayName,
                withButton: isBundleChosen,
                withExtraDetails: !isBundleChosen
            })
        ]
    });
};
/* harmony default export */ var base_bundle_section = (BaseBundleSection);


/***/ }),

/***/ 2058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ bundles_section; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/bundles-section/images/bone.svg
/* harmony default export */ var bone = ({"src":"/_next/static/media/bone.d5abd823.svg","height":165,"width":102});
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/bundles-section/images/glasses.svg
/* harmony default export */ var glasses = ({"src":"/_next/static/media/glasses.5b996c50.svg","height":91,"width":167});
// EXTERNAL MODULE: ./src/client/images/hand-right.svg
var hand_right = __webpack_require__(80136);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/service-group-panel/index.tsx + 4 modules
var service_group_panel = __webpack_require__(89634);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/snake-separator/index.tsx + 1 modules
var snake_separator = __webpack_require__(82024);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/bundles-section/styles.module.sass
var styles_module = __webpack_require__(79303);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/bundles-section/images/zen-tree.svg
/* harmony default export */ var zen_tree = ({"src":"/_next/static/media/zen-tree.ee3560ea.svg","height":170,"width":147});
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/bundles-section/index.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: initial;\n  transform: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 75px;\n  right: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -1.5rem;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}














var _PRODUCT_LIMIT_CATEGORY = ahm_constants/* default.PRODUCT_LIMIT_CATEGORY */.Z.PRODUCT_LIMIT_CATEGORY, MUSCLE_BONE = _PRODUCT_LIMIT_CATEGORY.MUSCLE_BONE, OPTICAL = _PRODUCT_LIMIT_CATEGORY.OPTICAL, WELLBEING = _PRODUCT_LIMIT_CATEGORY.WELLBEING;
var PanelImage = (0,styled_components_browser_esm["default"])(ahm_ui/* Image */.Ee).withConfig({
    componentId: "sc-1fff57e1-0"
})(_templateObject(), function(param) {
    var $isCondensed = param.$isCondensed;
    return $isCondensed ? "scale(0.8)" : "none";
});
var GlassesImage = (0,styled_components_browser_esm["default"])(PanelImage).withConfig({
    componentId: "sc-1fff57e1-1"
})(_templateObject1(), function(param) {
    var $isCondensed = param.$isCondensed;
    return $isCondensed ? "190px" : "220px";
});
var BoneImage = (0,styled_components_browser_esm["default"])(PanelImage).withConfig({
    componentId: "sc-1fff57e1-2"
})(_templateObject2(), function(param) {
    var $isCondensed = param.$isCondensed;
    return $isCondensed ? "rotate(-10deg) scale(0.8)" : "rotate(-10deg)";
});
var StyledSection = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-1fff57e1-3"
})(_templateObject3());
var AnchorId = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1fff57e1-4"
})(_templateObject4());
var getBundles = function(isCondensed) {
    return [
        {
            id: MUSCLE_BONE,
            image: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoneImage, {
                $isCondensed: isCondensed,
                src: bone.src,
                alt: "Illustration of a bone"
            })
        },
        {
            id: OPTICAL,
            image: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                        sm: true,
                        xs: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlassesImage, {
                            $isCondensed: isCondensed,
                            src: glasses.src,
                            alt: "Illustration of glasses"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                        df: true,
                        lg: true,
                        md: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PanelImage, {
                            $isCondensed: isCondensed,
                            src: glasses.src,
                            alt: "Illustration of glasses"
                        })
                    })
                ]
            })
        },
        {
            id: WELLBEING,
            image: /*#__PURE__*/ (0,jsx_runtime.jsx)(PanelImage, {
                $isCondensed: isCondensed,
                src: zen_tree.src,
                alt: "Illustration of a bonsai tree"
            })
        }, 
    ];
};
var BundlesSection = function(param) {
    var allIncludedServices = param.allIncludedServices, isCondensed = param.isCondensed, scale = param.scale, selectedBundles = param.selectedBundles, setSelectedBundles = param.setSelectedBundles;
    var onChange = function(id) {
        var isAlreadySelected = (0,fp.includes)(id, selectedBundles);
        var processSelection = isAlreadySelected ? fp.without : function(arg1, arg2) {
            return (0,fp.concat)(arg2, arg1);
        };
        var newSelectedBundles = processSelection([
            id
        ], selectedBundles);
        setSelectedBundles(newSelectedBundles);
    };
    var bundles = getBundles(isCondensed);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnchorId, {
                id: "bundles-section"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Wrapper */.im, {
                size: "large",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* SpacerWrapper */.Cj, {
                    variant: isCondensed ? "paddingBottomSpacer9" : "paddingBottomSpacer7",
                    children: [
                        !isCondensed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                                    src: hand_right/* default.src */.Z.src,
                                    alt: "Illustration of a hand",
                                    className: (styles_module_default()).handImageTop
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                                    src: hand_right/* default.src */.Z.src,
                                    alt: "Illustration of a hand",
                                    className: (styles_module_default()).handImageBottom
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                            looksLike: "h3",
                            variant: [
                                "marginBottomSpacer9",
                                "center"
                            ],
                            children: "Now add up to 3 bundles"
                        })
                    ]
                })
            }),
            (0,fp.map)(function(param) {
                var id = param.id, image = param.image;
                var ref;
                var isLastPanel = id === ((ref = (0,fp.last)(bundles)) === null || ref === void 0 ? void 0 : ref.id);
                var includedServices = (0,fp.find)({
                    limitId: id
                }, allIncludedServices);
                if (!includedServices) {
                    return null;
                }
                var isSelected = (0,fp.includes)(id, selectedBundles);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    className: classnames_default()((styles_module_default()).serviceGroupPanel, (0,_define_property/* default */.Z)({}, (styles_module_default()).isCondensed, isCondensed)),
                    "data-test": id,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(service_group_panel/* default */.Z, {
                            id: id,
                            isSelected: isSelected,
                            image: image,
                            limits: includedServices.limits,
                            onClick: function() {
                                return onChange(id);
                            },
                            scale: scale,
                            services: includedServices.services,
                            title: includedServices.displayName
                        }),
                        !isLastPanel && !isCondensed && /*#__PURE__*/ (0,jsx_runtime.jsx)(snake_separator/* default */.Z, {
                            hideOn: [
                                "xs",
                                "sm"
                            ]
                        })
                    ]
                }, id);
            }, bundles)
        ]
    });
};
BundlesSection.defaultProps = {
    allIncludedServices: [],
    isCondensed: false
};
/* harmony default export */ var bundles_section = (BundlesSection);


/***/ }),

/***/ 98985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36456);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93590);
/* harmony import */ var _actions_choosable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67687);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10453);
/* harmony import */ var _disclaimer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20074);
/* harmony import */ var _actions_drawer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56774);
/* harmony import */ var _components_premium_review_toggle_wrapper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12224);
/* harmony import */ var _models_price__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2798);
/* harmony import */ var _models_product__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(43735);
/* harmony import */ var _selectors_select_cart__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(1767);
/* harmony import */ var _selectors_select_is_premium_change_enabled__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(45424);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(93288);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _utils_truncate_frequency__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34237);
/* harmony import */ var _models_url__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26789);



















var _PRODUCT_TYPE = _ahm_constants__WEBPACK_IMPORTED_MODULE_7__/* ["default"].PRODUCT_TYPE */ .Z.PRODUCT_TYPE, EXTRAS = _PRODUCT_TYPE.EXTRAS, HOSPITAL = _PRODUCT_TYPE.HOSPITAL;
var BundleChosenView = function(param) {
    var customer = param.customer, effectiveDate = param.effectiveDate, isCondensed = param.isCondensed, prices = param.prices, productId = param.productId, isBundleChosen = param.isBundleChosen;
    var ref;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var isPremiumChangeEnabled = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_selectors_select_is_premium_change_enabled__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z);
    var cart = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_selectors_select_cart__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z);
    var hospitalId = cart === null || cart === void 0 ? void 0 : (ref = cart.hospital) === null || ref === void 0 ? void 0 : ref.id;
    var cartProductId = productId;
    if (hospitalId) {
        cartProductId = _models_product__WEBPACK_IMPORTED_MODULE_12__/* ["default"].getCombinedId */ .Z.getCombinedId({
            id: hospitalId,
            type: HOSPITAL
        }, {
            id: productId,
            type: EXTRAS
        });
    }
    var productUrl = _models_url__WEBPACK_IMPORTED_MODULE_15__/* ["default"].getProductUrl */ .Z.getProductUrl(cartProductId);
    var onRefinePriceClick = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        _actions_drawer__WEBPACK_IMPORTED_MODULE_9__/* ["default"].openDrawer */ .Z.openDrawer(_ahm_constants_ui__WEBPACK_IMPORTED_MODULE_5__.DRAWER_IDS.CHANGE_DETAILS)(dispatch);
    }, [
        dispatch
    ]);
    var onDoneClick = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        _actions_choosable__WEBPACK_IMPORTED_MODULE_6__/* ["default"].setChoosableComparerProductId */ .Z.setChoosableComparerProductId(productId)(dispatch);
        // @ts-expect-error - Automatic, Please fix when editing this file
        _actions_drawer__WEBPACK_IMPORTED_MODULE_9__/* ["default"].closeDrawer */ .Z.closeDrawer(_ahm_constants_ui__WEBPACK_IMPORTED_MODULE_5__.DRAWER_IDS.PICKER)(dispatch);
    }, [
        dispatch,
        productId
    ]);
    // @ts-expect-error - Automatic, Please fix when editing this file
    var rawPrice = _models_price__WEBPACK_IMPORTED_MODULE_11__/* ["default"].getPrice */ .Z.getPrice(prices, productId, customer, {
        date: effectiveDate
    });
    var price = rawPrice ? _models_price__WEBPACK_IMPORTED_MODULE_11__/* ["default"].getAmountAsObject */ .Z.getAmountAsObject(rawPrice, customer.frequency) : null;
    var priceVariantStyles = [
        "inlineSpinner",
        (_styles_module_sass__WEBPACK_IMPORTED_MODULE_17___default().price),
        isPremiumChangeEnabled ? (_styles_module_sass__WEBPACK_IMPORTED_MODULE_17___default().premiumPrice) : {}
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_disclaimer__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                showRefineLink: !isCondensed
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_styles_module_sass__WEBPACK_IMPORTED_MODULE_17___default().container), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, "".concat((_styles_module_sass__WEBPACK_IMPORTED_MODULE_17___default().isCondensed)), isCondensed)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_17___default().priceWrapper),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Price */ .tA, {
                                frequency: (0,_utils_truncate_frequency__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(customer.frequency),
                                isFrequencyInline: true,
                                price: price,
                                showAsterisk: true,
                                variant: priceVariantStyles
                            }),
                            isPremiumChangeEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_17___default().premiumChangeWrapper),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_premium_review_toggle_wrapper__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                                    type: _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_5__.PREMIUM_REVIEW_TOGGLE_STYLE.READ_ONLY
                                })
                            }),
                            !isCondensed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Clickable */ .P3, {
                                onClick: onRefinePriceClick,
                                variant: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_17___default().refinePriceLink),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Strong */ .cK, {
                                    variant: "small",
                                    children: "Refine price"
                                })
                            })
                        ]
                    }),
                    isCondensed ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                        onClick: onDoneClick,
                        variant: [
                            (_styles_module_sass__WEBPACK_IMPORTED_MODULE_17___default().doneButton),
                            "marginBottomSpacer11"
                        ],
                        children: "Done"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                        variant: [
                            "border",
                            "purple",
                            (_styles_module_sass__WEBPACK_IMPORTED_MODULE_17___default().button)
                        ],
                        to: productUrl,
                        children: isBundleChosen ? "View cover" : "View teeth only"
                    })
                ]
            })
        ]
    });
};
BundleChosenView.defaultProps = {
    effectiveDate: null,
    isCondensed: false,
    prices: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (BundleChosenView);


/***/ }),

/***/ 20074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);
/* harmony import */ var _components_price_disclaimer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76383);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96075);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_5__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 1;\n  margin-right: 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var DisclaimerContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-d6fe584d-0"
})(_templateObject());
var Disclaimer = function(param) {
    var _showRefineLink = param.showRefineLink, showRefineLink = _showRefineLink === void 0 ? true : _showRefineLink;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DisclaimerContainer, {
        className: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_5___default().disclaimer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_price_disclaimer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
            bold: true,
            highlightIncome: true,
            showRefineLinkInline: showRefineLink
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Disclaimer);


/***/ }),

/***/ 89634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ service_group_panel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/utils/summarise-waiting-periods/index.ts



var groupServicesByWaitingPeriod = function(serviceGroups, service) {
    // @ts-expect-error - Automatic, Please fix when editing this file
    var waitingPeriod = service.waitingPeriod.standard;
    var existingGroupForWaitingPeriod = (0,fp.find)({
        waitingPeriod: waitingPeriod
    }, serviceGroups);
    if (existingGroupForWaitingPeriod) {
        existingGroupForWaitingPeriod.serviceItemNames.push((0,fp.toLower)(service.name));
        return serviceGroups;
    }
    return (0,_to_consumable_array/* default */.Z)(serviceGroups).concat([
        {
            serviceItemNames: [
                (0,fp.toLower)(service.name)
            ],
            waitingPeriod: waitingPeriod
        }
    ]);
};
var formattedDurations = {
    M: "month",
    d: "day",
    y: "year"
};
var durationRegexp = new RegExp("(\\d+)(".concat((0,fp.keys)(formattedDurations).join("|"), ")$"));
var formatWaitingPeriod = function(duration) {
    if ((0,fp.isNil)(duration)) {
        return "No";
    }
    var matches = duration.match(durationRegexp);
    if ((0,fp.isNull)(matches)) {
        return duration;
    }
    var _matches = (0,_sliced_to_array/* default */.Z)(matches, 3), number = _matches[1], unit = _matches[2];
    // @ts-expect-error - Automatic, Please fix when editing this file
    return "".concat(number, " ").concat(formattedDurations[unit]);
};
// this adds a separator to each item name - a comma and space between each, with an ampersand between the last two
var buildSeparatedServiceItemNames = function(serviceItemNames) {
    return (0,fp.flow)((0,fp.map)(function(name) {
        var isLastItem = name === (0,fp.last)(serviceItemNames);
        if (isLastItem) {
            return name;
        }
        var isSecondLastItem = name === (0,fp.nth)(-2, serviceItemNames) && (0,fp.size)(serviceItemNames) > 1;
        if (isSecondLastItem) {
            return "".concat(name, " & ");
        }
        return "".concat(name, ", ");
    }), (0,fp.join)(""))(serviceItemNames);
};
var summariseWaitingPeriods = function(services) {
    var groupedServicesByWaitingPeriod = (0,fp.reduce)(groupServicesByWaitingPeriod, [], services);
    groupedServicesByWaitingPeriod = (0,fp.sortBy)(function(item) {
        return (0,fp.size)(item.serviceItemNames);
    }, groupedServicesByWaitingPeriod);
    var hasMoreThanOneGroup = (0,fp.size)(groupedServicesByWaitingPeriod) > 1;
    var lastGroup = (0,fp.last)(groupedServicesByWaitingPeriod);
    // @ts-expect-error - Automatic, Please fix when editing this file
    var lastGroupHasMoreThanOneService = (0,fp.size)(lastGroup.serviceItemNames) > 1;
    var shouldSummariseLastGroup = hasMoreThanOneGroup && lastGroupHasMoreThanOneService;
    if (shouldSummariseLastGroup) {
        // @ts-expect-error - Automatic, Please fix when editing this file
        lastGroup.serviceItemNames = [
            "other included services"
        ];
    }
    var shouldNotPrintServiceNames = !hasMoreThanOneGroup;
    if (shouldNotPrintServiceNames) {
        // @ts-expect-error - Automatic, Please fix when editing this file
        return [
            "".concat(formatWaitingPeriod(lastGroup.waitingPeriod), " waiting period")
        ];
    }
    return (0,fp.map)(function(group) {
        var serviceItemNames = buildSeparatedServiceItemNames(group.serviceItemNames);
        return "".concat(formatWaitingPeriod(group.waitingPeriod), " waiting period for ").concat(serviceItemNames);
    }, groupedServicesByWaitingPeriod);
};
/* harmony default export */ var summarise_waiting_periods = (summariseWaitingPeriods);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/titled-collapse/styles.module.sass
var styles_module = __webpack_require__(36787);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/titled-collapse/index.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  opacity: 1;\n  transition: opacity 0.25s;\n  transition-delay: 0.25s;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var Transition = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-88e80ce7-0"
})(_templateObject(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "" : "\n    opacity: 0;\n    transition:none;\n  ";
});
var Flex = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-88e80ce7-1"
})(_templateObject1());
var TitledCollapse = function(param) {
    var body = param.body, id = param.id, title = param.title;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ariaControls = "trigger-".concat(id);
    var titleComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Span */.Dr, {
        variant: "bold",
        className: (styles_module_default()).headerText,
        children: title
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Hidden */._G, {
                md: true,
                lg: true,
                df: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).header,
                        children: titleComponent
                    }),
                    body
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                xs: true,
                sm: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                            "aria-expanded": isOpen,
                            "aria-controls": ariaControls,
                            isUnstyled: true,
                            onClick: function() {
                                return setIsOpen(!isOpen);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).header,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((styles_module_default()).caret, // @ts-expect-error - Automatic, Please fix when editing this file
                                        (0,_define_property/* default */.Z)({}, (styles_module_default()).isCaretClosed, !isOpen))
                                    }),
                                    titleComponent
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Collapse */.UO, {
                            ariaControls: ariaControls,
                            isOpen: isOpen,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Transition, {
                                isOpen: isOpen,
                                children: body
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var titled_collapse = (TitledCollapse);

// EXTERNAL MODULE: ./src/utils/uncap-fp-iterator.ts
var uncap_fp_iterator = __webpack_require__(96852);
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/collapsed-section/index.tsx

function collapsed_section_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    collapsed_section_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function collapsed_section_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0.75rem;\n"
    ]);
    collapsed_section_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var SCALE = ahm_constants/* default.SCALE */.Z.SCALE, SERVICE = ahm_constants/* default.SERVICE */.Z.SERVICE, TEETH = ahm_constants/* default.PRODUCT_LIMIT_CATEGORY.TEETH */.Z.PRODUCT_LIMIT_CATEGORY.TEETH;
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-dbc5a706-0"
})(collapsed_section_templateObject());
var LineSpacer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-dbc5a706-1"
})(collapsed_section_templateObject1());
var mapWithIndex = (0,uncap_fp_iterator/* default */.Z)(fp.map);
var CollapsedSection = function(param) {
    var id = param.id, limits = param.limits, scale = param.scale, services = param.services;
    var isSingleScale = scale === SCALE.SINGLE;
    var hasOrthodontics = (0,fp.some)({
        id: SERVICE.ORTHODONTICS
    }, services);
    var orthodonticsLimit = /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineSpacer, {
        children: [
            "$",
            limits.lifetime,
            " Orthodontics lifetime limit per person"
        ]
    });
    var individualLimits = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "$",
            limits.individual,
            " bundle limit per person",
            hasOrthodontics ? orthodonticsLimit : null
        ]
    });
    var familyLimits = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "$",
            limits.family,
            " family bundle limit",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineSpacer, {
                children: [
                    "with a $",
                    limits.individual,
                    " bundle limit per person"
                ]
            }),
            hasOrthodontics ? orthodonticsLimit : null
        ]
    });
    var limitsBody = isSingleScale ? individualLimits : familyLimits;
    var text = mapWithIndex(function(waitingPeriodSummary, index) {
        return index === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: waitingPeriodSummary
        }, waitingPeriodSummary) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LineSpacer, {
            children: waitingPeriodSummary
        }, waitingPeriodSummary);
    }, summarise_waiting_periods(services));
    var benefitBackText = id === TEETH && !hasOrthodontics ? "50% back on included extras" : "60% back on included extras";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(titled_collapse, {
            body: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* SpacerWrapper */.Cj, {
                variant: "paddingTopSpacer9",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* IconList */.Zd, {
                    variant: "simple",
                    itemSpacerSize: 9,
                    items: [
                        {
                            icon: "time",
                            text: text
                        },
                        {
                            icon: "dollar-sign",
                            text: limitsBody
                        },
                        {
                            icon: "percent",
                            text: benefitBackText
                        }, 
                    ]
                })
            }),
            id: id,
            title: "Waiting periods, limits & percentage back"
        })
    });
};
/* harmony default export */ var collapsed_section = (CollapsedSection);

// EXTERNAL MODULE: ./node_modules/@ahmdigital/constants/lib/src/index.js
var src = __webpack_require__(13294);
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/extra-details-section/index.tsx

function extra_details_section_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    extra_details_section_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function extra_details_section_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 1rem;\n"
    ]);
    extra_details_section_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var StyledContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1ade8292-0"
})(extra_details_section_templateObject());
var StyledTitle = (0,styled_components_browser_esm["default"])(ahm_ui/* Strong */.cK).withConfig({
    componentId: "sc-1ade8292-1"
})(extra_details_section_templateObject1());
var content = [
    {
        id: src.PRODUCT_LIMIT_CATEGORY.TEETH,
        items: [
            {
                icon: "arrow-right-long",
                text: "Orthodontics with an $1,800 lifetime limit"
            },
            {
                icon: "arrow-right-long",
                text: "Increased bundle limit to $800"
            },
            {
                icon: "arrow-right-long",
                text: "Increased benefit back to 60%"
            }, 
        ],
        title: "Add another bundle to increase your inclusions, limits and percentage back"
    }, 
];
var ExtraDetailsSection = function(param) {
    var id = param.id;
    var extraDetails = content.find(function(item) {
        return item.id === id;
    });
    if (!extraDetails) {
        return null;
    }
    var items = extraDetails.items, title = extraDetails.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* IconList */.Zd, {
                variant: "simple",
                iconSize: "extraSmall",
                items: items
            })
        ]
    });
};
/* harmony default export */ var extra_details_section = (ExtraDetailsSection);

;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/service-group-panel/index.tsx



function service_group_panel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    service_group_panel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function service_group_panel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n"
    ]);
    service_group_panel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var colors = ahm_ui/* theme.colors */.rS.colors;
var TopContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-3ea4a5a4-0"
})(service_group_panel_templateObject());
var TopContentTitle = (0,styled_components_browser_esm["default"])(ahm_ui.H3).withConfig({
    componentId: "sc-3ea4a5a4-1"
})(service_group_panel_templateObject1());
var Panel = function(param) {
    var className = param.className, id = param.id, image = param.image, isDisabled = param.isDisabled, isSelected = param.isSelected, limits = param.limits, onClick = param.onClick, scale = param.scale, services = param.services, title = param.title, _withButton = param.withButton, withButton = _withButton === void 0 ? true : _withButton, _withExtraDetails = param.withExtraDetails, withExtraDetails = _withExtraDetails === void 0 ? false : _withExtraDetails;
    var inclusions = (0,fp.map)("name", services);
    var lowercaseTitle = (0,fp.toLower)(title);
    var topContent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopContentWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* SpacerWrapper */.Cj, {
                    variant: "marginBottomSpacer8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                            isBlock: true,
                            md: true,
                            lg: true,
                            df: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                                children: lowercaseTitle
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                            xs: true,
                            sm: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopContentTitle, {
                                looksLike: "h4",
                                children: lowercaseTitle
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Strong */.cK, {
                    variant: "marginBottomSpacer10",
                    children: "What’s included"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* IconList */.Zd, {
                    variant: "simple",
                    itemSpacerSize: 10,
                    items: (0,fp.map)(function(inclusion) {
                        var iconProps = isSelected ? {
                            fill: colors.green,
                            icon: "tick-circle"
                        } : {
                            icon: "tick-circle-light"
                        };
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, iconProps), {
                            text: inclusion
                        });
                    }, inclusions)
                })
            ]
        });
    };
    var bottomContent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(collapsed_section, {
            id: id,
            limits: limits,
            scale: scale,
            services: services
        });
    };
    var extraDetailsContent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(extra_details_section, {
            id: id
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* ServiceGroupPanel */.Xb, {
        TopContent: topContent,
        BottomContent: bottomContent,
        ExtraDetailsContent: withExtraDetails ? extraDetailsContent : null,
        buttonLabels: {
            checked: "Chosen",
            disabled: "Base bundle",
            unchecked: "Choose me"
        },
        image: image,
        isSelected: isSelected,
        isDisabled: isDisabled,
        onClick: onClick,
        serviceGroupName: lowercaseTitle,
        className: className,
        withButton: withButton
    });
};
Panel.defaultProps = {
    className: null,
    image: null,
    isDisabled: false,
    isSelected: false,
    onClick: fp.noop
};
/* harmony default export */ var service_group_panel = (Panel);


/***/ }),

/***/ 82024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ snake_separator; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/snake-separator/styles.module.sass
var styles_module = __webpack_require__(84721);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/snake-separator/images/vertical-dashed-line.svg
/* harmony default export */ var vertical_dashed_line = ({"src":"/_next/static/media/vertical-dashed-line.204a188a.svg","height":107,"width":18});
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/snake-separator/index.tsx








var SnakeSeparator = function(param) {
    var hideOn = param.hideOn;
    var hiddenProps = (0,fp.reduce)(function(propsObject, value) {
        return (0,fp.set)(value, true, propsObject);
    }, {}, hideOn);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isBlock: true
    }, hiddenProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* SpacerWrapper */.Cj, {
            variant: [
                "paddingTopSpacer7",
                "paddingBottomSpacer7",
                (styles_module_default()).wrapper
            ],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                src: vertical_dashed_line.src,
                role: "presentation"
            })
        })
    }));
};
SnakeSeparator.defaultProps = {
    hideOn: []
};
/* harmony default export */ var snake_separator = (SnakeSeparator);


/***/ }),

/***/ 57107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ determineProductIdFromBundles; },
/* harmony export */   "M": function() { return /* binding */ determineBundlesFromProductId; }
/* harmony export */ });
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10453);


var _PRODUCT = _ahm_constants__WEBPACK_IMPORTED_MODULE_1__/* ["default"].PRODUCT */ .Z.PRODUCT, CHOOSABLE_60_TEETH_EYES = _PRODUCT.CHOOSABLE_60_TEETH_EYES, CHOOSABLE_60_TEETH_EYES_MUSCLE_BONE = _PRODUCT.CHOOSABLE_60_TEETH_EYES_MUSCLE_BONE, CHOOSABLE_60_TEETH_EYES_WELLBEING = _PRODUCT.CHOOSABLE_60_TEETH_EYES_WELLBEING, CHOOSABLE_60_TEETH_EYES_WELLBEING_MUSCLE_BONE = _PRODUCT.CHOOSABLE_60_TEETH_EYES_WELLBEING_MUSCLE_BONE, CHOOSABLE_60_TEETH_MUSCLE_BONE = _PRODUCT.CHOOSABLE_60_TEETH_MUSCLE_BONE, CHOOSABLE_60_TEETH_WELLBEING = _PRODUCT.CHOOSABLE_60_TEETH_WELLBEING, CHOOSABLE_60_TEETH_WELLBEING_MUSCLE_BONE = _PRODUCT.CHOOSABLE_60_TEETH_WELLBEING_MUSCLE_BONE, _PRODUCT_LIMIT_CATEGORY = _ahm_constants__WEBPACK_IMPORTED_MODULE_1__/* ["default"].PRODUCT_LIMIT_CATEGORY */ .Z.PRODUCT_LIMIT_CATEGORY, MUSCLE_BONE = _PRODUCT_LIMIT_CATEGORY.MUSCLE_BONE, OPTICAL = _PRODUCT_LIMIT_CATEGORY.OPTICAL, WELLBEING = _PRODUCT_LIMIT_CATEGORY.WELLBEING;
var PRODUCT_BUNDLES_MAPPING = [
    {
        bundles: [
            OPTICAL
        ],
        product: CHOOSABLE_60_TEETH_EYES
    },
    {
        bundles: [
            MUSCLE_BONE,
            OPTICAL
        ],
        product: CHOOSABLE_60_TEETH_EYES_MUSCLE_BONE
    },
    {
        bundles: [
            OPTICAL,
            WELLBEING
        ],
        product: CHOOSABLE_60_TEETH_EYES_WELLBEING
    },
    {
        bundles: [
            MUSCLE_BONE,
            OPTICAL,
            WELLBEING
        ],
        product: CHOOSABLE_60_TEETH_EYES_WELLBEING_MUSCLE_BONE
    },
    {
        bundles: [
            MUSCLE_BONE
        ],
        product: CHOOSABLE_60_TEETH_MUSCLE_BONE
    },
    {
        bundles: [
            WELLBEING
        ],
        product: CHOOSABLE_60_TEETH_WELLBEING
    },
    {
        bundles: [
            MUSCLE_BONE,
            WELLBEING
        ],
        product: CHOOSABLE_60_TEETH_WELLBEING_MUSCLE_BONE
    }, 
];
var determineProductIdFromBundles = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.memoize)(function(selectedBundles) {
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.size)(selectedBundles) === 0) {
        return null;
    }
    var match = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.find)(function(param) {
        var bundles = param.bundles;
        return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEqual)(bundles, (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.sortBy)(lodash_fp__WEBPACK_IMPORTED_MODULE_0__.identity, selectedBundles));
    }, PRODUCT_BUNDLES_MAPPING);
    return match === null || match === void 0 ? void 0 : match.product;
});
var determineBundlesFromProductId = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.memoize)(function(productId) {
    var match = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.find)(function(param) {
        var product = param.product;
        return product === productId;
    }, PRODUCT_BUNDLES_MAPPING);
    var ref;
    return (ref = match === null || match === void 0 ? void 0 : match.bundles) !== null && ref !== void 0 ? ref : [];
});


/***/ }),

/***/ 5684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10453);

var CHOOSABLE_60_TEETH_EYES_WELLBEING_MUSCLE_BONE = _ahm_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].PRODUCT.CHOOSABLE_60_TEETH_EYES_WELLBEING_MUSCLE_BONE */ .Z.PRODUCT.CHOOSABLE_60_TEETH_EYES_WELLBEING_MUSCLE_BONE;
var getChoosableAllIncludedServices = function(products) {
    var ref, ref1;
    return (products === null || products === void 0 ? void 0 : (ref = products[CHOOSABLE_60_TEETH_EYES_WELLBEING_MUSCLE_BONE]) === null || ref === void 0 ? void 0 : (ref1 = ref.extras) === null || ref1 === void 0 ? void 0 : ref1.included) || [];
};
/* harmony default export */ __webpack_exports__["Z"] = (getChoosableAllIncludedServices);


/***/ }),

/***/ 34237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);

var truncateFrequency = function(frequency) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.replace)("ly", "", frequency);
};
/* harmony default export */ __webpack_exports__["Z"] = (truncateFrequency);


/***/ }),

/***/ 13545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);

var getOrNull = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.getOr)(null);
var selectChoosableComparerProductId = getOrNull("choosable.comparerProductId");
/* harmony default export */ __webpack_exports__["Z"] = (selectChoosableComparerProductId);


/***/ }),

/***/ 93830:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
// @ts-expect-error - Automatic, Please fix when editing this file
var selectHasPartnerReferrer = function(state) {
    var ref;
    return !!(state === null || state === void 0 ? void 0 : (ref = state.referrer) === null || ref === void 0 ? void 0 : ref.hasPartnerReferrer);
};
/* harmony default export */ __webpack_exports__["Z"] = (selectHasPartnerReferrer);


/***/ }),

/***/ 3110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10453);


var SERVICE = _ahm_constants__WEBPACK_IMPORTED_MODULE_1__/* ["default"].SERVICE */ .Z.SERVICE;
// Choosable extras with Orthodontics have lifetime limits that don't apply to other services in the group
// For this reason they're on the service object itself, so we retrieve limits from there if they're present
// @ts-expect-error - Automatic, Please fix when editing this file
var getOrthodonticsLifetimeLimit = function(services) {
    var ref;
    var orthodonticsService = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.find)({
        id: SERVICE.ORTHODONTICS
    }, services);
    return orthodonticsService === null || orthodonticsService === void 0 ? void 0 : (ref = orthodonticsService.limits) === null || ref === void 0 ? void 0 : ref.lifetime;
};
/* harmony default export */ __webpack_exports__["Z"] = (getOrthodonticsLifetimeLimit);


/***/ }),

/***/ 41732:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","wrapper":"styles_wrapper__fSUuc","isStacked":"styles_isStacked__tLIsP","image":"styles_image__GqKP5"};

/***/ }),

/***/ 79303:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","handImageTop":"styles_handImageTop__oEqCS","handImageBottom":"styles_handImageBottom__bIZ_v","serviceGroupPanel":"styles_serviceGroupPanel__gIrlx","isCondensed":"styles_isCondensed__Qj8h2"};

/***/ }),

/***/ 93288:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","container":"styles_container__zEUCd","isCondensed":"styles_isCondensed__Lz2c1","price":"styles_price__xe0SX","refinePriceLink":"styles_refinePriceLink__2DCxo","button":"styles_button__qe0Ik","doneButton":"styles_doneButton__3qLeX","premiumChangeWrapper":"styles_premiumChangeWrapper__cLv3k","premiumPrice":"styles_premiumPrice__zqGBm"};

/***/ }),

/***/ 96075:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","disclaimer":"styles_disclaimer__J0SWD"};

/***/ }),

/***/ 84721:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","wrapper":"styles_wrapper__wO0D7"};

/***/ }),

/***/ 36787:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","wrapper":"styles_wrapper__YeKXr","header":"styles_header__96JRw","headerText":"styles_headerText__9AnHk","caret":"styles_caret__p978N","isCaretClosed":"styles_isCaretClosed__aIwvR"};

/***/ })

}]);